export const registerHelper = ({ ref, ...inputProps }) => ({ inputRef: ref, ...inputProps })
export const registerSwitchHelper = ({ ref, value, ...inputProps }) => ({
  inputRef: ref, value, checked: value, ...inputProps,
})
